import { Machine } from '@modules/test-development/components/run-results/machine-config/machine/machine';
import { TestDevice } from '@testsigmainc/models';
import classNames from 'classnames';
import React from 'react';

interface TestDeviceIconGroupProps {
  environments: TestDevice[];
  variant?: 'machines' | 'labs';
  testPlanId?: string | number;
  labTypeVariant?: 'detail' | 'concise';
  hideLaptypeIcon?: boolean;
}

const TestDeviceIconGroup: React.FC<TestDeviceIconGroupProps> = ({
  environments,
  variant = 'machines',
  testPlanId,
  labTypeVariant,
  hideLaptypeIcon,
}) => {
  return (
    <div
      className={classNames(
        'flex flex-row flex-wrap gap-5 !text-secondary-500',
        {
          'gap-5': variant == 'machines',
          'gap-1': variant == 'labs',
        },
      )}
    >
      {environments.map((environment: TestDevice, idx) => (
        <Machine
          key={idx}
          className={variant === 'machines' ? '!gap-x-1.5' : '!gap-x-0'}
          testDevice={environment}
          showOsType={variant === 'machines'}
          showDeviceType={variant === 'machines'}
          testPlanId={testPlanId}
          variant={labTypeVariant}
          hideLaptypeIcon={hideLaptypeIcon}
        />
      ))}
    </div>
  );
};

export default TestDeviceIconGroup;
